import { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaPsicometricasInterface } from "../../../../../interfaces/FechaPsicometricasInterface";
import { SemaforoPsiInterface } from "../../../../../interfaces/SemaforoPsiInterface";
import { ConclusionesPsiInterface } from "../../../../../interfaces/ConclusionesPsiInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { Label, TextInput } from "flowbite-react";
import { Button } from "flowbite-react";
import { API } from "../../../../../global/global";
import Semaforo from "../../../../../img/Semaforo.png";
import Rojo from "../../../../../img/Rojo.png";
import Amarillo from "../../../../../img/Amarillo.png";
import Verde from "../../../../../img/Verde.png";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";
import { ConclusionesPSMPrint } from "./ConclusionesPSMPrint";

export const ConclusionesPSMListaScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "CONCLUSIÓN PSICOMETRICA";
  const { control, reset, setValue } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<string[]>([""]);
  const [notes, setNotes] = useState<string[]>([]);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  const [formData, setFormData] = useState({
    visitDate: "",
    name: "",
  });

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);

    localStorage.setItem("formData", JSON.stringify(updatedFormData));
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [""]);
    setCurrentPage(newPage);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    console.log("Datos guardados:", {
      ...formData,
      images,
    });

    navigate(`/domiciliaria/${evaluadosList_id}`);
  };

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFechaPSI = useGetData<FechaPsicometricasInterface[]>({
    url: `/fecha_psicometricas/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha_psicometricas"],
  });

  const querySemaforoPSI = useGetData<SemaforoPsiInterface>({
    url: `/semaforo_psi/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "semaforo_psi"],
  });

  const queryConclusionesPSI = useGetData<ConclusionesPsiInterface[]>({
    url: `/conclusiones_psi/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "conclusiones_psi"],
  });

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const [selectedImage, setSelectedImage] = useState(Semaforo);
  const [selectedRecommendation, setSelectedRecommendation] = useState<
    string | null
  >(null);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelectedRecommendation(value);

    if (value === "recomendable") {
      setSelectedImage(Verde);
    } else if (value === "con_reserva") {
      setSelectedImage(Amarillo);
    } else if (value === "no_recomendable") {
      setSelectedImage(Rojo);
    }
  };

  const handlePrint = () => {
    const printContent = document.getElementById("printableContent");

    if (printContent) {
      const printWindow = window.open("", "", "width=800,height=600");

      if (printWindow) {
        printWindow.document.write(`
          <html>
            <head>
              <title>Vista Previa de Impresión</title>
              <style>
                @media print {
                  body {
                    margin: 20px;
                    font-family: Arial, sans-serif;
                  }
                }
              </style>
            </head>
            <body>${printContent.innerHTML}</body>
          </html>
        `);

        const styles = document.styleSheets;
        for (let i = 0; i < styles.length; i++) {
          try {
            if (styles[i].cssRules) {
              const styleTag = printWindow.document.createElement("style");
              for (let j = 0; j < styles[i].cssRules.length; j++) {
                styleTag.appendChild(
                  printWindow.document.createTextNode(
                    styles[i].cssRules[j].cssText
                  )
                );
              }
              printWindow.document.head.appendChild(styleTag);
            }
          } catch (e) {
            console.warn("No se pudo copiar una hoja de estilo:", e);
          }
        }

        printWindow.document.close();
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
            printWindow.close();
          }, 500);
        };
      } else {
        alert("No se pudo abrir la ventana de impresión.");
      }
    }
  };

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      console.log("Fecha de nacimiento:", fechaNac);
      console.log("Edad calculada:", nuevaEdad);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
            console.log("URL de la foto:", data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  useEffect(() => {
    if (queryFechaPSI.data && queryFechaPSI.data.length > 0) {
      const fechaPSI = queryFechaPSI.data[0];
      reset({
        fecha_conclusionpsi: fechaPSI.fecha_conclusionpsi || "",
        evaluado_uuid: fechaPSI.evaluado_uuid || "",
      });
    }
  }, [queryFechaPSI.data, reset]);

  useEffect(() => {
    if (querySemaforoPSI.data) {
      const color = querySemaforoPSI.data.color_psi || "";

      let recommendation = "";
      if (color === "verde") {
        recommendation = "recomendable";
      } else if (color === "amarillo") {
        recommendation = "con_reserva";
      } else if (color === "rojo") {
        recommendation = "no_recomendable";
      }

      reset({
        color_psi: color,
        evaluado_uuid: querySemaforoPSI.data.evaluado_uuid || "",
      });

      setSelectedRecommendation(recommendation);

      if (recommendation === "recomendable") {
        setSelectedImage(Verde);
      } else if (recommendation === "con_reserva") {
        setSelectedImage(Amarillo);
      } else if (recommendation === "no_recomendable") {
        setSelectedImage(Rojo);
      }
    }
  }, [querySemaforoPSI.data, reset]);

  useEffect(() => {
    if (queryConclusionesPSI.data && queryConclusionesPSI.data.length > 0) {
      const notasPSI = queryConclusionesPSI.data[0];
      reset({
        motivo_psicom: notasPSI.motivo_psicom || "",
        tipo_psicom: notasPSI.tipo_psicom || "",
        nota_1psicom: notasPSI.nota_1psicom || "",
        nota_2psicom: notasPSI.nota_2psicom || "",
        nota_3psicom: notasPSI.nota_3psicom || "",
        resultado_psicom: notasPSI.resultado_psicom || "",
        evaluado_uuid: notasPSI.evaluado_uuid || "",
      });
    }
  }, [queryConclusionesPSI.data, reset]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  const renderPage1 = () => (
    <div className="space-y-4 p-4">
      <div className="grid grid-cols-3 gap-4">
        {/* Fecha Visita */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fechaVisita" className={`mr-2 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            FECHA EVALUACIÓN:
          </Label>
          <Controller
            name="fecha_conclusionpsi"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="fecha_conclusionpsi"
                type="date"
                value={
                  field.value ||
                  (queryFechaPSI.data && queryFechaPSI.data.length > 0
                    ? queryFechaPSI.data[0]?.fecha_conclusionpsi || ""
                    : "")
                }
                disabled={true}
                onChange={(e) => field.onChange(e.target.value)}
                className={`text-center w-full ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
              />
            )}
          />
        </div>
        {/* Campo para nombre */}
        <div className="col-span-2">
          <Label htmlFor="nombre" className={`${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>NOMBRE:</Label>
          <TextInput
            id="nombre"
            name="nombre"
            value={`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
            onChange={handleInputChange}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
          />
        </div>

        {/* FOTO */}
        <div className={`w-64 h-64 border rounded-md overflow-hidden flex items-center justify-center mt-4 relative z-10 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-100"}`}>
          {photoUrl ? (
            <img
              src={photoUrl}
              alt="Foto de evaluado"
              className="w-full h-full object-cover"
            />
          ) : (
            <span className={`${isDarkMode ? "text-gray-400" : "text-gray-500"}`}>Sin foto disponible</span>
          )}
        </div>
        {/* SEMAFORO */}
        <div className="flex items-center gap-4">
          {/* Radio buttons */}
          <div className="flex flex-col">
            <label className={`flex items-center gap-2 mt-4 mb-4 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              <input
                type="radio"
                name="recommendation"
                value="recomendable"
                checked={selectedRecommendation === "recomendable"}
                onChange={handleRadioChange}
                disabled={true}
              />
              RECOMENDABLE
            </label>
            <label className={`flex items-center gap-2 mt-12 mb-12 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              <input
                type="radio"
                name="recommendation"
                value="con_reserva"
                checked={selectedRecommendation === "con_reserva"}
                onChange={handleRadioChange}
                disabled={true}
              />
              CON RESERVA
            </label>
            <label className={`flex items-center gap-2 mb-12 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              <input
                type="radio"
                name="recommendation"
                value="no_recomendable"
                checked={selectedRecommendation === "no_recomendable"}
                onChange={handleRadioChange}
                disabled={true}
              />
              NO RECOMENDABLE
            </label>
          </div>
          {/* Imagen de Semaforo */}
          <img src={selectedImage} alt="Semaforo" className="w-70 h-70" />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        {/* Campo para RFC */}
        <div className="col-span-1">
          <Label htmlFor="rfc">RFC:</Label>
          <TextInput
            id="rfc"
            name="rfc"
            onChange={handleInputChange}
            value={queryEvaluado.data?.rfc || ""}
            disabled={true}
          />
        </div>
        {/* Edad */}
        <div className="col-span-1">
          <Label htmlFor="edad">EDAD:</Label>
          <TextInput
            id="edad"
            name="edad"
            value={edad !== null ? edad.toString() : ""}
            disabled={true}
          />
        </div>
        {/* Género */}
        <div className="col-span-1">
          <Label htmlFor="sexo">SEXO:</Label>
          <TextInput
            id="sexo"
            name="sexo"
            onChange={handleInputChange}
            value={queryEvaluado.data?.genero || ""}
            disabled={true}
          />
        </div>
        {/* Estado Civil */}
        <div className="col-span-1">
          <Label htmlFor="estadoCivil">ESTADO CIVIL:</Label>
          <TextInput
            id="estadoCivil"
            name="estadoCivil"
            onChange={handleInputChange}
            value={queryEvaluado.data?.estado_civil || ""}
            disabled={true}
          />
        </div>
        {/* Escolaridad */}
        <div className="col-span-1">
          <Label htmlFor="escolaridad">ESCOLARIDAD:</Label>
          <TextInput
            id="escolaridad"
            name="escolaridad"
            onChange={handleInputChange}
            value={queryEvaluado.data?.escolaridad || ""}
            disabled={true}
          />
        </div>
        {/* Fecha de Nacimiento */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fechaNacimiento" className="mr-2">
            FECHA DE NACIMIENTO:
          </Label>
          <TextInput
            id="fechaNacimiento"
            name="fechaNacimiento"
            value={queryEvaluado.data?.fecha_nacimiento || ""}
            disabled={true}
            type="date"
            className="w-32"
          />
        </div>
        {/* CURP */}
        <div className="col-span-1">
          <Label htmlFor="curp">CURP:</Label>
          <TextInput
            id="curp"
            name="curp"
            onChange={handleInputChange}
            value={queryEvaluado.data?.curp || ""}
            disabled={true}
          />
        </div>
        {/* Empresa */}
        <div className="col-span-1">
          <Label htmlFor="empresa">EMPRESA:</Label>
          <TextInput
            id="empresa_id"
            name="empresa"
            value={queryEvaluado.data?.empresa_id?.nombre || ""}
            onChange={handleInputChange}
            disabled={true}
          />
        </div>
        {/* Motivo de la evaluación */}
        <div className="col-span-1">
          <Label htmlFor="motivo_psicom" className={`${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>MOTIVO DE LA EVALUACIÓN:</Label>
          <Controller
            name="motivo_psicom"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="motivo_psicom"
                type="text"
                value={
                  field.value ||
                  (queryConclusionesPSI.data &&
                  queryConclusionesPSI.data.length > 0
                    ? queryConclusionesPSI.data[0]?.motivo_psicom || ""
                    : "")
                }
                disabled={true}
                onChange={(e) => field.onChange(e.target.value)}
                className={`w-full ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
              />
            )}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="tipo_psicom" className={`${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>TIPO:</Label>
          <Controller
            name="tipo_psicom"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="tipo_psicom"
                type="text"
                value={
                  field.value ||
                  (queryConclusionesPSI.data &&
                  queryConclusionesPSI.data.length > 0
                    ? queryConclusionesPSI.data[0]?.tipo_psicom || ""
                    : "")
                }
                onChange={(e) => field.onChange(e.target.value)}
                className={`w-full ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                disabled={true}
              />
            )}
          />
        </div>
      </div>
    </div>
  );

  const renderPage2 = () => (
    <div className={`space-y-6 p-6 rounded-lg shadow-md ${isDarkMode ? "bg-gray-700" : "bg-gray-50"}`}>
      <div className={`text-white p-4 rounded-lg shadow ${isDarkMode ? "bg-blue-700" : "bg-customBlue"}`}>
        <h2 className="font-bold text-xl">RESULTADO GENERAL</h2>
      </div>

      <div className={`flex flex-col items-center border-dashed border-4 rounded-lg p-8 space-y-4 relative ${isDarkMode ? "border-gray-500 bg-gray-600" : "border-gray-300 bg-gray-100"}`}>
        {/* Área para agregar notas */}
        <div className="w-full mt-4">
          <span className={`mb-2 text-justify block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            Se realizó una valoración, análisis y revisión con la finalidad de
            identificar los riesgos en conjunto, dado lo anterior se encontró lo
            siguiente en el proceso de evaluación:
          </span>
          <span className={`mb-2 text-justify block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            Se considera que es una{" "}
            <strong>
              PERSONA{" "}
              {querySemaforoPSI.data?.color_psi === "verde"
                ? "RECOMENDABLE"
                : querySemaforoPSI.data?.color_psi === "amarillo"
                ? "CON RESERVA"
                : querySemaforoPSI.data?.color_psi === "rojo"
                ? "NO RECOMENDABLE"
                : ""}
            </strong>{" "}
            ya que:
          </span>
          <label
            htmlFor="nombre"
            className={`font-normal inline-block text-justify ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {queryConclusionesPSI.data && queryConclusionesPSI.data.length > 0
              ? (queryConclusionesPSI.data[0]?.nota_1psicom || "")
                  .split("\n")
                  .map((paragraph, index) => (
                    <p key={index} className="mb-2">
                      {" "}
                      {paragraph}
                    </p>
                  ))
              : ""}
          </label>
          <span className="mt-2 mb-2 text-justify block">
            Al momento de la evaluación se observó también lo siguiente:
          </span>
          <label
            htmlFor="nombre"
            className="text-gray-800 font-normal inline-block text-justify"
          >
            {queryConclusionesPSI.data && queryConclusionesPSI.data.length > 0
              ? (queryConclusionesPSI.data[0]?.nota_2psicom || "")
                  .split("\n")
                  .map((paragraph, index) => (
                    <p key={index} className="mb-2">
                      {" "}
                      {paragraph}
                    </p>
                  ))
              : ""}
          </label>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {/* Campo Resultado */}
        <div className="col-span-1">
          <Label htmlFor="resultado_psicom" className={`${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>RESULTADO:</Label>
          <br />
          <Controller
            name="resultado_psicom"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input
                type="text"
                id="resultado_psicom"
                value={
                  field.value ||
                  (queryConclusionesPSI.data &&
                  queryConclusionesPSI.data.length > 0
                    ? queryConclusionesPSI.data[0]?.resultado_psicom || ""
                    : "")
                }
                disabled={true}
                onChange={(e) => field.onChange(e.target.value)}
                className={`text-left w-auto border rounded ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
              />
            )}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className="container mx-auto p-4">
        <form
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}
          onSubmit={handleSubmit}
        >
        {renderHeader()}

        {currentPage === 1 && renderPage1()}
        {currentPage === 2 && renderPage2()}

        <div className="mt-6 p-4 flex justify-between">
          {currentPage === 1 && (
            <Button
              color="red"
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(`/psicometrica/${evaluadosList_id}`);
              }}
              className={`ml-2 bg-red-500 hover:bg-red-600 text-white dark:bg-red-600 dark:hover:bg-red-700`}
            >
              Cancelar
            </Button>
          )}

          {currentPage > 1 && (
            <Button
              color="blue"
              onClick={() => {
                window.scrollTo(0, 0);
                handlePageChange(currentPage - 1);
              }}
              className={`bg-blue-500 hover:bg-blue-600 text-white dark:bg-blue-600 dark:hover:bg-blue-700`}
            >
              Anterior
            </Button>
          )}

          {currentPage < 2 && (
            <button
              type="button"
              className={`rounded px-4 py-2 ${isDarkMode ? "bg-blue-600 hover:bg-blue-700 text-white" : "bg-blue-500 hover:bg-blue-600 text-white"}`}
              onClick={() => {
                window.scrollTo(0, 0);
                handlePageChange(currentPage + 1);
              }}
            >
              Siguiente
            </button>
          )}

          {/* Botón Guardar */}
          {currentPage === 2 && (
            <div className="flex space-x-4">
              <Button 
                color="blue" 
                onClick={handlePrint}
                className={`bg-blue-500 hover:bg-blue-600 text-white dark:bg-blue-600 dark:hover:bg-blue-700`}
              >
                Imprimir
              </Button>
              <button
                type="button"
                className={`rounded px-4 py-2 ${isDarkMode ? "bg-red-600 hover:bg-red-700 text-white" : "bg-red-500 hover:bg-red-600 text-white"}`}
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(`/psicometrica/${evaluadosList_id}`);
                }}
              >
                Salir
              </button>
            </div>
          )}
        </div>
      </form>
      {/* Imprimir */}
      <div id="printableContent" style={{ display: "none" }}>
        <ConclusionesPSMPrint />
      </div>
      </div>
    </div>
  );
};
